var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M13.585 14.379A7.457 7.457 0 1 0 3.33 3.548a7.457 7.457 0 0 0 10.254 10.83Zm0 0 5.127 5.127"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .506h20v20H0z"
  })))));
};
export { SvgIconSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xMy41ODQ1IDE0LjM3ODhDMTUuMDE5NyAxMy4wMTk2IDE1LjkxNDkgMTEuMDk2IDE1LjkxNDkgOC45NjMzM0MxNS45MTQ5IDQuODQ0NjggMTIuNTc2MSAxLjUwNTg2CjguNDU3NDcgMS41MDU4NkM0LjMzODgyIDEuNTA1ODYgMSA0Ljg0NDY4IDEgOC45NjMzM0MxIDEzLjA4MiA0LjMzODgyIDE2LjQyMDggOC40NTc0NyAxNi40MjA4QzEwLjQ0MzQKMTYuNDIwOCAxMi4yNDggMTUuNjQ0NSAxMy41ODQ1IDE0LjM3ODhaTTEzLjU4NDUgMTQuMzc4OEwxOC43MTE1IDE5LjUwNTkiCiAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUwNTg1OSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";